// Market resolution hero — share event. Fires when the user shares their
// per-market result card via the new `market_result` ShareSurface. The
// existing `share_clicked` event still fires for the generic `market`
// surface used by no-position viewers — `market_result_shared` is strictly
// the per-wallet card variant.

import type { EventDefinition } from './navigation';
import type { PnlCardSharedMethod } from './pnl-card-shared';

export type MarketResultSharedProperties = {
  marketPubkey: string;
  walletPubkey: string;
  method: PnlCardSharedMethod;
};

export const MARKET_RESULT_SHARED: EventDefinition<MarketResultSharedProperties> = {
  name: 'market_result_shared',
};
